import { Box, styled } from '@material-ui/core';

// Styled components
export const LoaderContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '24px',
  height: '100%',
  width: '100%',
  marginTop: '5vh',
  gap: '32px'
});

export const HeaderText = styled(Box)({
  fontSize: '20px',
  fontWeight: 600,
  textAlign: 'center'
});

export const StepsContainer = styled(Box)({
  display: 'flex',
  gap: '24px',
  flexDirection: 'column',
  justifyContent: 'space-between',

  width: '100%',
  maxWidth: '600px',
  maxHeight: '248px',
  height: '100%',
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '30px',
  boxShadow:
    '0px 16px 32px -4px rgba(48, 54, 60, 0.10), 0px 2px 4px 0px rgba(48, 54, 60, 0.04)'
});

export const StepItem = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '12px',
  transition: 'all 0.3s ease'
});

export const StepIconContainer = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '24px',
  height: '24px'
});

export const StepText = styled(Box)(
  ({
    isActive,
    isCompleted
  }: {
    isActive?: boolean;
    isCompleted?: boolean;
  }) => ({
    fontSize: '16px',
    color: isActive && !isCompleted ? 'transparent' : '#5D7083',
    backgroundImage:
      isActive && !isCompleted
        ? 'linear-gradient(135deg, #7A5FFF 5%, #00C2FF 90%)'
        : 'none',
    backgroundClip: isActive && !isCompleted ? 'text' : 'none',
    WebkitBackgroundClip: isActive && !isCompleted ? 'text' : 'none',
    transition: 'all 0.3s ease'
  })
);

export const FooterContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '2px',
  textAlign: 'center'
});

export const BulletContainer = styled(Box)({
  width: 20,
  height: 20,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center'
});

export const Bullet = styled(Box)({
  width: 4,
  height: 4,
  borderRadius: '50%',
  backgroundColor: '#5D7083'
});

export const Bold = styled('b')(({ theme }) => ({
  color: theme.palette.primary.main
}));

export const IconContainer = styled(Box)(({ theme }) => ({
  padding: 4,
  borderRadius: '50%',
  background: theme.palette.primary.main,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));
